import {TypographyIcon} from '@primer/octicons-react'
import {type FilterProvider, FilterProviderType} from '../types'

export const RawTextProvider: FilterProvider = {
  type: FilterProviderType.RawText,
  icon: TypographyIcon,
  key: 'text',
  priority: 5,
  displayName: 'Text',
  getSuggestions: () => [],
  validateFilterBlockValues: () => [],
  getValueRowProps: () => ({text: ''}),
}
